import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";

const Index = () => {
  const [form] = Form.useForm();
  const [certificate, setCertificate] = useState(false);
  const [records, setRecords] = useState(false);
  const [tenant, setTenant] = useState(false);
  const [hazard, setHazard] = useState(false);

  const hazardChanges = (e) => {
    if (e.target.value == "Lead_Paint_Hazards") {
      setHazard(true);
    } else {
      setHazard(false);
    }
  };

  const tenantChanges = (e) => {
    if (e.target.value == "Tenant_Records_Provided") {
      setTenant(true);
    } else {
      setTenant(false);
    }
  };

  const certificateChange = (e) => {
    if (e.target.value === "Lead_Paint_Hazards") {
      setCertificate(true);
      setRecords(false);
    } else if (e.target.value === "Owner_Lessor_Records") {
      setRecords(true);
      setCertificate(false);
    } else {
      setCertificate(false);
      setRecords(false);
    }
  };

  const subData = async (values) => {
    console.log(values);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/residential-renantal-agreement`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Residential Rental Agreement"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Form onFinish={subData} form={form} autoComplete="off">
      <div className="main">
        <label>MASSACHUSETTS RESIDENTIAL MONTH-TO-MONTH AGREEMENT</label>
        <div style={{ marginTop: "2rem" }}>
          <Row>
            <Col md={4} style={{ marginTop: "2.6rem" }}>
              <label>Agreement dated</label>
            </Col>
            <Col md={8}>
              <label>Start</label>
              <Form.Item
                name={"agreement_start_date"}
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>End</label>
              <Form.Item
                name={"agreement_end_date"}
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row justify={"space-between"} gutter={16}>
            <Col md={10}>
              <label>Landlord is</label>
              <Form.Item
                name={"landlord_is"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Landlord is" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Landlord of</label>
              <Form.Item
                name={"landlord_off"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Landlord of" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row justify={"space-between"} gutter={16}>
            <Col md={10}>
              <label>Tenant is</label>
              <Form.Item
                name={"tenant_is"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Tenant is" />
              </Form.Item>
            </Col>
            <Col md={10}>
              {" "}
              <label>Tenant are</label>
              <Form.Item
                name={"tenant_of"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Tenant of" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <label>Rental Property Address</label>
          <Form.Item
            name={"Rental_Property_Address"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input placeholder="Rental Property Address" />
          </Form.Item>
        </div>
        <div>
          <label>Agreement start</label>
          <Form.Item
            name={"Agreement_Date"}
            rules={[{ required: true, message: "required!" }]}
          >
            <DatePicker />
          </Form.Item>
        </div>
        <div>
          <label>Occupant Name</label>
          <Form.Item
            name={"Occupant_Name"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input name="Occupant Name" />
          </Form.Item>
        </div>

        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>Monthly Rent Amount</label>
              <Form.Item
                name={"Monthly_Rent_Amount"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Rental Payments Reciever</label>
              <Form.Item
                name={"Rental_Payments_Reciever"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Rental Payments Reciever" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row justify={"space-between"} gutter={16}>
            <Col md={10}>
              <label>First Month Rent</label>
              <Form.Item
                name={"_month_rent"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Last Month Rent</label>
              <Form.Item
                name={"last_month_rent"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>Security Deposit</label>
              <Form.Item
                name={"security_deposit_amount"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Total Moving Cost</label>
              <Form.Item
                name={"total_moving_cost"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>Late fee</label>
              <Form.Item
                name={"late_fee"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Returned Payments</label>
              <Form.Item
                name="returned_payments"
                rules={[
                  {
                    required: true,
                    message: "Returned payments are required!",
                  },
                ]}
              >
                <Input type="number" placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <label>Tenant Security Deposit</label>
          <Form.Item
            name={"Tenant_Security_Deposit"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input placeholder="$" style={{ width: "50%" }} />
          </Form.Item>
        </div>
        <hr />
        <div>
          <label>Utilites & Services</label>
          <Row
            justify={"space-between"}
            gutter={16}
            style={{ marginTop: "2rem" }}
          >
            <Col md={10}>
              <label>
                Tenant is responsible for the following utilities and services
              </label>
              <Form.Item
                name={"tenant_utilities_details"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>
                Landlord will be responsible for the following utilities and
                services
              </label>
              <Form.Item
                name={"landlord_utilities_details"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <hr />
        <label>STATEMENT OF CONDITION</label>
        <div>
          <Row
            gutter={12}
            justify={"space-between"}
            style={{ marginTop: "2rem" }}
          >
            <Col md={8}>
              <label>Landlord's Name</label>
              <Form.Item
                name={"landlords_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Tenant's Name</label>
              <Form.Item
                name={"tenant_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Rental Premises Address</label>
              <Form.Item
                name={"rental_premises_address"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <label>Landlord's Statement</label>
          <Form.Item
            name={"landlord_statement"}
            rules={[{ required: true, message: "required!" }]}
          >
            <TextArea rows={5} style={{ resize: "none" }} />
          </Form.Item>
        </div>
        <hr />
        <label style={{ marginTop: "2rem" }}>
          RECEIPT FORFIRSTMONTH'S RENT, LAST MONTH'S RENT AND/OR SECURITY
          DEPOSIT
        </label>
        <div style={{ marginTop: "2rem" }}>
          <Row gutter={16} justify={"space-between"}>
            <Col md={8}>
              <label>Amount Received</label>
              <Form.Item
                name={"total_recieved_funds"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Tenant 1</label>
              <Form.Item
                name={"tanent_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Tenant" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Address 1</label>
              <Form.Item
                name={"tanent_address"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Address" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row gutter={8} justify={"space-between"}>
            <Col md={8}>
              <label>Tenant 2</label>
              <Form.Item
                name={"tanent_name_2nd"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Tenant" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Address 2</label>
              <Form.Item
                name="tanent_address_2nd"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="Address " />
              </Form.Item>
            </Col>
            <Col md={8}></Col>
          </Row>
        </div>
        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>Property Address</label>
              <Form.Item
                name={"property_address"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Application of Funds</label>
              <Form.Item
                name="application_of_funds"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={8}>
              <label>First Month's Rent</label>
              <Form.Item
                name={"first_month_rent"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Last Month's Rent</label>{" "}
              <Form.Item
                name={"last_month_rent"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Security Deposit</label>{" "}
              <Form.Item
                name={"security_deposit"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Row justify={"space-between"} gutter={12}>
            <Col md={8}>
              <label>Purchase & Installation Cost For Lock & Key</label>
              <Form.Item
                name="Purchase_Installation_Cost"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Fee To Rental Agent</label>
              <Form.Item
                name="Fee_To_Rental_Agent"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Name Of Person Receiving Payment</label>
              <Form.Item
                name={"Person_Receiving_Payment"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <hr />

        <div>
          <Row>
            <Col md={9}>
              <label>Addendum are incorporated lease date</label>
              <Form.Item name={"addendum_lease_date"}>
                <DatePicker />
              </Form.Item>
            </Col>
            <Col md={5}>
              <label>Premises number b/t</label>
              <Form.Item name={"premises_number"}>
                <InputNumber />
              </Form.Item>
            </Col>
            <Col md={5}>
              <label>Premises number</label>
              <Form.Item name={"premises_number_b"}>
                <InputNumber />
              </Form.Item>
            </Col>
            <Col md={5}>
              <label>landlord name</label>
              <Form.Item name={"landlord_name_addendum"}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <label>Tenant Name</label>
          <Form.Item name="tenant_name_addendum">
            <Input style={{ width: "50%" }} />
          </Form.Item>
        </div>

        <hr />
        <label>Zero tolerance for criminal activity</label>
        <div style={{ marginTop: "2rem" }}>
          <Row justify={"space-between"} gutter={12}>
            <Col md={8}>
              <label>Landlord Name</label>
              <Form.Item
                name={"zero_landlord_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Tanent Name</label>
              <Form.Item
                name={"zero_tanent_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Leased Premises</label>
              <Form.Item
                name={"zero_leased_premises"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <hr />
        <label>Tenant guest policy</label>
        <div style={{ marginTop: "2rem" }}>
          <Row justify={"space-between"} gutter={12}>
            <Col md={8}>
              <label>Landlord Name</label>
              <Form.Item
                name={"guest_landlord_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Tanent Name</label>
              <Form.Item
                name={"guest_tanent_name"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              {" "}
              <label>Contract Start Date</label>
              <Form.Item
                name={"contract_start_Date"}
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <hr />
        <label>Tenant Certification Form</label>
        <div style={{ marginTop: "2rem" }}>
          <Form.Item
            name="certificate_options"
            rules={[{ required: true, message: "Please select one option!" }]} // Rule for the main radio group
          >
            <Radio.Group onChange={certificateChange}>
              <Row gutter={16} justify={"space-between"}>
                <Col md={14}>
                  <Radio value={"Lead_Paint_Hazards"}>
                    Presence of lead-based paint and/or lead-based paint hazards
                  </Radio>
                  <div style={{ marginLeft: "2rem" }}>
                    {certificate && (
                      <Form.Item
                        name={"Lead_Paint_Hazard_options"}
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Radio.Group onChange={hazardChanges}>
                          <Radio value="Lead_Paint_Hazards">
                            Known lead-based paint and/or lead-based paint
                            hazards are present in the housing
                          </Radio>
                          <div style={{ marginLeft: "1rem" }}>
                            {" "}
                            {hazard && (
                              <>
                                <Form.Item
                                  name={"Lead_Paint_Hazards_details"}
                                  rules={[
                                    { required: true, message: "required!" },
                                  ]}
                                >
                                  <Input placeholder="Details" />
                                </Form.Item>
                              </>
                            )}
                          </div>
                          <Radio value="No_Knowledge_Lead_Paint">
                            Owner/Lessor has no knowledge of lead-based paint
                            and/or lead-based paint hazards in the housing
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    )}
                  </div>
                </Col>
                <Col md={10}>
                  <Radio value={"Owner_Lessor_Records"}>
                    Records and reports available to the owner/lessor
                  </Radio>
                  <div style={{ marginLeft: "1rem" }}>
                    {records && (
                      <Form.Item
                        name="Owner_Lessor_Records_options"
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Radio.Group onChange={tenantChanges}>
                          <Radio value="Tenant_Records_Provided">
                            Owner/Lessor has provided the tenant with all
                            available records and reports pertaining to
                            lead-based paint and/or lead-based paint hazards in
                            the housing
                          </Radio>
                          <div style={{ marginLeft: "1rem" }}>
                            {tenant && (
                              <Form.Item
                                name="Tenant_Records_Provided_options"
                                rules={[
                                  { required: true, message: "required!" },
                                ]}
                              >
                                <Radio.Group>
                                  <Radio value="Lead_Inspection_Report">
                                    Lead Inspection Report
                                  </Radio>
                                  <Radio value="Risk_Assessment_Report">
                                    Risk Assessment Report
                                  </Radio>
                                  <Radio value="Letter_of_Interim_Control">
                                    Letter of Interim Control
                                  </Radio>
                                  <Radio value="Letter_of_Compliance">
                                    Letter of Compliance
                                  </Radio>
                                </Radio.Group>
                              </Form.Item>
                            )}
                          </div>
                          <Radio value="No_Records_Lead_Paint">
                            Owner/Lessor has no reports or records pertaining to
                            lead-based paint and/or lead-based paint hazards in
                            the housing.
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    )}
                  </div>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </div>

        <label>Tenant's Acknowledgment</label>
        <div style={{ marginTop: "2rem" }}>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>Tenant has received all checked documents</label>
              <Form.Item
                name="tenantReceivedDocuments"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>Tenant has received no documents listed above</label>
              <Form.Item
                name="tenantNoDocuments"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>
                Tenant has received the Massachusetts Tenant Lead Law
                Notification
              </label>
              <Form.Item
                name="tenantLeadLawNotification"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>
                Agent has informed the owner/lessor of their obligations under
                federal and state law regarding lead-based paint disclosure.
              </label>
              <Form.Item
                name="agentInformedObligations"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <label>Tenant Reason</label>
          <Form.Item
            name={"tenant_reason"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input />
          </Form.Item>
        </div>
        <div>
          <label>Property address</label>
          <Form.Item
            name={"property_address"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input />
          </Form.Item>
        </div>
      </div>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Index;
